import { inventoryEntryApi } from '../../api';
import { ApiResponse } from '../../types/common/ApiResponse';

const InventoryEntryService = {
  /**
   * Registra movimientos de inventario desde productos asentados
   * POST /api/inventory-entry/from-settlement?purchaseId=1
   */
  registerFromSettlement: async (
    purchaseId: number
  ): Promise<ApiResponse<null>> => {
    const response = await inventoryEntryApi.addCustom(
      `/from-settlement?purchaseId=${purchaseId}`,
      {} // cuerpo vacío ya que solo se necesita el query param
    );
    return response.data;
  },
};

export default InventoryEntryService;
